import React from 'react'
import cx from 'classnames'
import { ModalConsumer } from '../../common/ModalContext'
import Button from '../../components/Button/Button'
import { getCategoryText } from '../../reduxSetup/action'
import TYPE from '../../constants/searchType'
import COUNTRIES from '../../constants/countries'
import {
    getSelected,
    getButtonText,
    handleFieldChange,
} from "../../services/filters";
import { formSpotNamesConvertor } from "../../services/formNamesConvertor";
import { getSearchOptions } from "../../services/getSearchOptions";
import DropDown from '../../containers/DropDown/DropDown'
import ModalWithDropDown from "../../components/ModalWithDropDown/ModalWithDropDown";
import { connect } from 'react-redux'
import styles from './CategoriesTextsForm.module.scss'

const FindCategoriesForm = ({ getCategoryText, setFindType, setFindFields, setFindCountry, setFindState, findType = [], findFields = [], findCountry = [], findState = [] }) => {

    const findSubmit = () => {
        getCategoryText({
            type: findType,
            fields: findFields,
            country: findCountry,
            ...(findState?.[0] && findState[0] !== "all"
                ? { state: findState[0], fallback: "false" }
                : {}),
        })
    }

    return (
        <div className={styles.container}>

            <h6>Find by type, field, country, and state — each combination has its own text</h6>
            <div className={cx(styles.form)}>
                <DropDown
                    className={cx(styles.formType, styles.dropDownDesktop)}
                    name="type"
                    options={TYPE.filter((item) => !item.value.includes("New"))}
                    selected={findType}
                    onChange={(value) => setFindType([value])}
                    buttonText={getButtonText(
                        findType,
                        formSpotNamesConvertor("type"),
                        "type"
                    )}
                    onClear={() => setFindType([])}
                />
                <DropDown
                    name="fields"
                    className={cx(styles.formFields, styles.dropDownDesktop)}
                    onChange={(value) => setFindFields([value])}
                    selected={findFields}
                    onClear={() => setFindFields([])}
                    options={findType && getSearchOptions(findType[0])}
                    buttonText={getButtonText(
                        findFields,
                        "Fields",
                        findType[0]
                    )}
                />
                <DropDown
                    name="countries"
                    className={cx(styles.formFields, styles.dropDownDesktop)}
                    onChange={(value) => {
                        setFindCountry([value]);
                        if (value !== "USA") setFindState([]);
                    }}
                    selected={findCountry}
                    onClear={() => {
                        setFindCountry([]);
                        setFindState([]);
                    }}
                    options={COUNTRIES}
                    buttonText={getButtonText(
                        findCountry,
                        "Country",
                        "countries"
                    )}
                />
                {findCountry?.[0] === "USA" && (
                    <DropDown
                        name="usState"
                        className={cx(styles.formFields, styles.dropDownDesktop)}
                        onChange={(value) =>
                            setFindState(value === "all" ? [] : [value])
                        }
                        selected={findState}
                        onClear={() => setFindState([])}
                        options={getSearchOptions("states")}
                        buttonText={getButtonText(
                            findState,
                            "All USA",
                            "states"
                        )}
                    />
                )}
                <div className={cx(styles.form, styles.dropDownMobile)}>
                    <ModalConsumer>
                        {({ toggleModal }) => (
                            <>
                                <p
                                    className={cx(styles.fieldLabel)}
                                >
                                    Type*
                                </p>
                                <Button
                                    onClick={() => {
                                        toggleModal("findType");
                                    }}
                                    className={cx(
                                        styles.filterButton,
                                        findType.length
                                            ? styles.labelValue
                                            : styles.labelName
                                    )}
                                >
                                    {getButtonText(
                                        findType,
                                        "Type",
                                        "type"
                                    )}
                                </Button>
                            </>
                        )}
                    </ModalConsumer>
                </div>
                <div className={cx(styles.form, styles.dropDownMobile)}>
                    <ModalConsumer>
                        {({ toggleModal }) => (
                            <>
                                <p
                                    className={cx(styles.fieldLabel, styles.dropDownMobile)}
                                >
                                    Fields*
                                </p>
                                <Button
                                    onClick={() => {
                                        toggleModal("findFields");
                                    }}
                                    className={cx(
                                        styles.filterButton,
                                        findFields.length
                                            ? styles.labelValue
                                            : styles.labelName
                                    )}
                                >
                                    {findFields.length > 0 ? findFields[0] : "Fields"}
                                </Button>
                            </>
                        )}
                    </ModalConsumer>
                </div>
                <div className={cx(styles.form, styles.dropDownMobile)}>
                    <ModalConsumer>
                        {({ toggleModal }) => (
                            <>
                                <p
                                    className={cx(styles.fieldLabel, styles.dropDownMobile)}
                                >
                                    Country*
                                </p>
                                <Button
                                    onClick={() => {
                                        toggleModal("findCountry");
                                    }}
                                    className={cx(
                                        styles.filterButton,
                                        findCountry.length
                                            ? styles.labelValue
                                            : styles.labelName
                                    )}
                                >
                                    {getButtonText(
                                        findCountry,
                                        "Country",
                                        "countries"
                                    )}
                                </Button>
                            </>
                        )}
                    </ModalConsumer>
                </div>
                {findCountry?.[0] === "USA" && (
                    <div className={cx(styles.form, styles.dropDownMobile)}>
                        <ModalConsumer>
                            {({ toggleModal }) => (
                                <>
                                    <p
                                        className={cx(styles.fieldLabel, styles.dropDownMobile)}
                                    >
                                        State (empty = all USA)
                                    </p>
                                    <Button
                                        onClick={() => {
                                            toggleModal("findState");
                                        }}
                                        className={cx(
                                            styles.filterButton,
                                            findState.length
                                                ? styles.labelValue
                                                : styles.labelName
                                        )}
                                    >
                                        {getButtonText(
                                            findState,
                                            "All USA",
                                            "states"
                                        )}
                                    </Button>
                                </>
                            )}
                        </ModalConsumer>
                    </div>
                )}
                <Button
                    disabled={!findType && !findFields.length}
                    className={styles.submit}
                    onClick={findSubmit}
                >
                    Find
                </Button>
            </div>
            <ModalConsumer>
                {({ isOpen, toggleModal, modalId }) => {
                    return (
                        (modalId === "findType") && (
                            <ModalWithDropDown
                                onSave={toggleModal}
                                toggleModal={toggleModal}
                                isOpen={isOpen}
                                name={modalId}
                                options={TYPE.filter((item) => !item.value.includes("New"))}
                                selected={getSelected({
                                    modalId,
                                    findType
                                })}
                                onChange={handleFieldChange.bind({
                                    filter: modalId,
                                    changeFilter: (value) => setFindType(value),
                                    selected: getSelected({
                                        modalId,
                                        findType
                                    }),

                                })}
                                onClear={() => setFindType([])}
                            />
                        )
                    );
                }}
            </ModalConsumer>
            <ModalConsumer>
                {({ isOpen, toggleModal, modalId }) => {
                    return (
                        (modalId === "findFields") && (
                            <ModalWithDropDown
                                onSave={toggleModal}
                                toggleModal={toggleModal}
                                isOpen={isOpen}
                                name={modalId}
                                options={getSearchOptions(findType[0])}
                                selected={getSelected({
                                    modalId,
                                    findFields
                                })}
                                onChange={(value) => setFindFields([value])}
                                onClear={() => setFindFields([])}
                            />
                        )
                    );
                }}
            </ModalConsumer>
            <ModalConsumer>
                {({ isOpen, toggleModal, modalId }) => {
                    return (
                        (modalId === "findCountry") && (
                            <ModalWithDropDown
                                onSave={toggleModal}
                                toggleModal={toggleModal}
                                isOpen={isOpen}
                                name={modalId}
                                options={COUNTRIES}
                                selected={findCountry}
                                onChange={handleFieldChange.bind({
                                    filter: "countries",
                                    changeFilter: (value) => {
                                        setFindCountry(value);
                                        if (!(value?.[0] === "USA")) setFindState([]);
                                    },
                                    selected: getSelected({
                                        modalId: "countries",
                                        findCountry
                                    }),
                                })}
                                onClear={() => {
                                    setFindCountry([]);
                                    setFindState([]);
                                }}
                            />
                        )
                    );
                }}
            </ModalConsumer>
            <ModalConsumer>
                {({ isOpen, toggleModal, modalId }) => {
                    return (
                        (modalId === "findState") && (
                            <ModalWithDropDown
                                onSave={toggleModal}
                                toggleModal={toggleModal}
                                isOpen={isOpen}
                                name={modalId}
                                options={getSearchOptions("states")}
                                selected={findState}
                                onChange={handleFieldChange.bind({
                                    filter: "usState",
                                    changeFilter: (value) =>
                                        setFindState(value?.[0] === "all" ? [] : value),
                                    selected: findState,
                                })}
                                onClear={() => setFindState([])}
                            />
                        )
                    );
                }}
            </ModalConsumer>
        </div>
    )
}


const mapDispatchToProps = {
    getCategoryText
}

export default connect(null, mapDispatchToProps)(FindCategoriesForm)